import React from 'react';
import './SessionExpiredModal.css';

const SessionExpiredModal = ({ onClose }) => {
  const handleLogin = () => {
    // Clear token and redirect to login
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <div className="session-expired-overlay" onClick={handleLogin}>
      <div className="session-expired-modal" onClick={(e) => e.stopPropagation()}>
        <div className="session-expired-icon">⏰</div>
        <h2 className="session-expired-title">Session Expired</h2>
        <p className="session-expired-message">
          Your session has expired. Please log in again to continue.
        </p>
        <button className="session-expired-button" onClick={handleLogin}>
          Log In Again
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredModal;
